<template>
  <iframe
    width="100%"
    v-if="url"
    :src="url"
    onload="iFrameResize({}, this)"
  ></iframe>
</template>

<script>
import * as axios from "axios";
import iFrameResize from "iframe-resizer/js/iframeResizer";

export default {
  name: "DashBoard",
  props: ["src", "location"],
  created() {
    this.setUrl();
  },
  methods: {
    async setUrl() {
      let response;
      this.url = false;
      response = await axios.get(this.src + "?location=" + this.location);
      this.url = response.data.url;
    },
  },
  data() {
    return {
      url: null,
    };
  },
  watch: {
    src: function (val, old_val) {
      this.setUrl();
    },
  },
};

window.iFrameResizer = { targetOrigin: "mainPageUrl" };
if ("parentIFrame" in window) {
  parentIFrame.close();
}
</script>
